import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=24bfe98d&scoped=true&"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfe98d",
  null
  
)

export default component.exports